import { ValidatedInput } from '@idm/ui-components';

const { ValidationError } = ValidatedInput;

export { ValidationError as default };
